/**
 * @desc 是否锁定
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type IsLockedParameter = {
  device?: 0 | 1 | 2
}

const method = 'GET'
const url = '/auth/locked'

export const isLockedApi = (
  params?: IsLockedParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<boolean>({
    method,
    url,
    params,
    ...config
  })
}

isLockedApi.method = method
isLockedApi.url = url
